import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useSaleRoDetailModel } from "./saleRoDetailModel";
import { Description } from "@/components/YhBox/Description";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useDictModel } from "../../../../../base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useSaleRoModel } from "../../saleRoModel";
import { debounce } from "lodash";

interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    IYhFormRef: React.MutableRefObject<IYhFormRef | undefined>
}
export const TopButs: FC<ITopType> = ({ id, mode, IYhFormRef }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { setSelectedRowKeys, setDescRows, setSelectedRow } = useSaleRoModel()
    const { detailAddForm, detailLookForm, detailEditForm, insertDetail, editDetail, Settle, getDetailEditOne, WhConfirm, setDetailAddForm, setDetailAddList, resetAddCatch } = useSaleRoDetailModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();
    const save = async () => {
        IYhFormRef.current?.validateFields().then(async res => {
            if (mode == "add") {
                const resData = await insertDetail(res)
                if (resData) {
                    goBack();
                    // globalPrompt("message", { text: "新增成功", type: "success" });
                    globalPrompt("message", { text: Locale["Successfully added"], type: "success" });
                    resetAddCatch(mode);
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
                // resData == true && goBack() && globalPrompt("message", { text: "新增成功", type: "success" })
            } else if (mode == "edit") {
                let { returnCode, id } = detailEditForm
                const resData = await editDetail({ ...res, returnCode, id })
                // resData == true && goBack() && globalPrompt("message", { text: "编辑成功", type: "success" })
                resData == true && goBack() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })

            }
        })
    }
    const goBack = async () => {
        replaceNav(selectedNavId, "2-4")
    }
    const onSettle = async () => {
        let { returnCode, id } = detailEditForm
        let retData = await Settle({ returnCode, id })
        retData ? message.success("结算成功") && goBack() : message.error("结算失败")
    }
    const onWhConfirm = async () => {
        let { returnCode, id } = detailEditForm
        let retData = await WhConfirm({ returnCode, id })
        retData ? message.success("出库成功") && goBack() : message.error("出库失败")
    }
    const onRefresh = async () => {
        if (mode == 'add') {
            IYhFormRef.current?.resetFields()
            setDetailAddForm({})
            setDetailAddList([])

        } else if (mode == 'edit') {
            getDetailEditOne(id, mode)
        }
        // message.success("刷新成功")
        message.success(Locale["Successfully refreshed"])
    }
    const action = <>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={() => save()}
            onClick={debounce(() => { save() }, 900)}
        >{Locale["Save"]}</Button>}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
        {/* {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onSettle()}
        >结算</Button>}
        {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onWhConfirm()}
        >入库</Button>} */}
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onRefresh()}
        >{Locale["Refresh"]}</Button>}

    </>;

    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }
    const orderStatu: IDescription[] = [
        {
            label: Locale["Sales Return Doc No."],//"退货单号",
            value: typeTitle[mode]?.returnCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: Locale["Status"],//"状态",
            // value: (typeTitle[mode]?.status && getTreeNodeName(typeTitle[mode]?.status as string)) ?? Locale["Not yet"],
            value: (typeTitle[mode]?.status && (language == "zh-CN" ? getTreeNodeOne(typeTitle[mode]?.status as string)[0].name : getTreeNodeOne(typeTitle[mode]?.status as string)[0].nameEn as string)) ?? Locale["Not yet"],
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}